import {NXTPage} from "../Page/NXTPage";

export class JobDetailsPage extends NXTPage {
    replaceBackLink() {
        const backLink = document.querySelector('.back-to-job-search-link');
        const originalHref = backLink?.getAttribute('href');
        if (!originalHref) {
            return;
        }
        const url = new URL(originalHref, location.href);
        const jobListSearch: string | null = (new URLSearchParams(location.hash?.slice(1))).get('ref');
        if (!jobListSearch) {
            return;
        }
        url.search = jobListSearch;
        backLink.setAttribute('href', url.href);
    }

    initialize(): void {
        this.replaceBackLink();
    }

}
